// extracted by mini-css-extract-plugin
module.exports = {"cartIcon":"styles_cartIcon__3ofyC"};